import "ag-grid-community/dist/styles/ag-grid.css";
// import "ag-grid-community/dist/styles/ag-theme-alpine.css";
// import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridVue } from "ag-grid-vue";
import { TransactionService } from "@/services";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import $exponent from "@/mixins/exponent";
import $thousandMask from "@/mixins/thousandMask";
import symbolInTable from "@/components/WalletPage/SymbolInTable/index.vue";
import statusInTable from "@/components/TransactionsPage/StatusInTable/index.vue";
import PricesAndIsoInTable from "@/components/TransactionsPage/PricesAndIsoInTable/index.vue";
import verifyInTable from "@/components/TransactionsPage/VerifyInTable/index.vue";
import rangeInTable from "@/components/WalletPage/RangeInTable/index.vue";
import ProfitOrLosesPercentInTable from "@/components/WalletPage/ProfitOrLosesPercentInTable/index.vue";
import ProfitOrLosesAmountInTable from "@/components/WalletPage/ProfitOrLosesAmountInTable/index.vue";
import updateInTable from "@/components/WalletPage/UpdateInTable/index.vue";
import detailsInTable from "@/components/TransactionsPage/DetailsInTable/index.vue";
import draggable from "vuedraggable";
import { noRowsTemplate } from "../noRowsTemplate";
import dayjs from "dayjs";
import transactionsFilter from "@/components/TransactionsPage/TransactionsFilter/index";

export default {
  name: "transfer-table",
  components: {
    AgGridVue,
    symbolInTable,
    rangeInTable,
    ProfitOrLosesPercentInTable,
    ProfitOrLosesAmountInTable,
    updateInTable,
    draggable,
    detailsInTable,
    statusInTable,
    PricesAndIsoInTable,
    verifyInTable,
    transactionsFilter
  },
  mixins: [$exponent, $thousandMask],
  filters: {},
  data() {
    return {
      page: 1,
      loading: false,
      tab: 0,
      isMenuOpen: false,
      selectedFilter: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      dataTableShow: false,
      showMyPrices: false,
      keySearch: "",
      selected: [],
      arrowTopImage: require("../../../assets/image/up.svg"),
      arrowDownImage: require("../../../assets/image/down.svg"),
      dataTableItem: "",
      gridOptions: null,
      gridApi: null,
      localeText: null,
      columnApi: null,
      transferHeader: null,
      defaultWalletHeader: null,
      paginationPageSize: null,
      paginationNumberFormatter: null,
      tableItemShow: [
        { name: "10", value: 10 },
        { name: "20", value: 20 },
        { name: "30", value: 30 },
        { name: this.$t("transactionsPage.transferTable.all"), value: 100 }
      ],
      tableItemShowFirstIndex: 10,
      item: "10",
      statusQuery: {
        type: "transfer"
      },
      requestQuery: {},
      statusList: []
    };
  },
  watch: {
    getQueryParams: {
      deep: true,
      handler(newValue, oldValue) {
        // if (Object.entries(newValue).length > 0) {
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.getTransferOrderData(this.getQueryParams, 1);
          // }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      transactionsDrawer: types.transactions.getters.GET_TRANSACTIONS_DRAWER,
      getTransactionOrderData:
        types.transactions.getters.GET_TRANSACTIONS_ORDER,
      getTransactionStatusList:
        types.transactions.getters.ACTION_TRANSACTIONS_STATUS_LIST,
      getTransactionQuery: types.transactions.getters.ACTION_TRANSACTIONS_QUERY
    }),
    getQueryParams() {
      if (this.$route.query || Object.entries(this.$route.query).length > 0) {
        Object.entries(this.$route.query).forEach(([key, value]) => {
          if (
            (key === "status" || key === "currency") &&
            !Array.isArray(value)
          ) {
            this.$route.query[key] = [value];
          }
        });
        return this.$route.query;
      }
    },
    filterStatusList() {
      return this.statusList.filter(elem => {
        if (
          "status" in this.getQueryParams &&
          this.getQueryParams.status.includes(elem.value)
        ) {
          return elem;
        }
      });
    },
    showTransferData() {
      let data = [];
      if (Object.entries(this.getTransactionOrderData).length > 0) {
        this.getTransactionOrderData.data.forEach(elem => {
          data.push({
            transaction_id: elem.reference_number,
            currency: {
              logo: elem.currency_logo,
              iso: elem.currency_name
            },
            amount: {
              value: elem.amount,
              iso: elem.currency_iso
            },
            date:
              elem.status.value === "PROCESSING"
                ? "-"
                : this.formatTimes(elem.created_at) +
                  " - " +
                  this.formatDate(elem.created_at),
            // time: this.formatTimes(elem.created_at),
            status: { locale: elem.status.locale, style: elem.status.style },
            verify: {
              type: elem.status.value,
              reference_number: elem.reference_number,
              orderType: "transfer"
            },
            operation: {
              transaction_type: "transfer",
              drawer: true,
              reference_number: elem.reference_number
            }
          });
        });
        return data;
      }
    },
    showPaginationCount() {
      if (Object.entries(this.getTransactionOrderData).length > 0) {
        return this.getTransactionOrderData.pagination;
      }
    }
  },
  beforeMount() {
    this.localeText = {
      to: this.$t("transactionsPage.transferTable.to"),
      of: this.$t("transactionsPage.transferTable.from")
    };
    this.gridOptions = {
      overlayNoRowsTemplate: noRowsTemplate.template
    };
    this.transferHeader = [
      {
        colId: 0,
        headerName: this.$t("transactionsPage.transferTable.crypto"),
        field: "currency",
        // sortable: true,
        unSortIcon: true,
        cellRendererFramework: "symbolInTable",
        flex: 1,
        minWidth: 200
      },
      {
        colId: 1,
        headerName: this.$t("transactionsPage.transferTable.amount"),
        field: "amount",
        // sortable: true,
        unSortIcon: true,
        cellRendererFramework: "PricesAndIsoInTable",
        flex: 1,
        minWidth: 200
      },
      {
        colId: 2,
        headerName: this.$t("transactionsPage.transferTable.transactionId"),
        field: "transaction_id",
        flex: 1,
        minWidth: 200
      },
      {
        colId: 3,
        headerName: this.$t("transactionsPage.transferTable.date"),
        field: "date",
        // sortable: true,
        unSortIcon: true,
        flex: 1,
        minWidth: 200,
        cellClass: "ag-grid-date-class"
      },
      // {
      //   colId: 4,
      //   headerName: this.$t("transactionsPage.transferTable.time"),
      //   field: "time",
      //   // sortable: true,
      //   unSortIcon: true,
      //   flex: 1,
      //   minWidth: 200
      // },
      {
        colId: 5,
        headerName: this.$t("transactionsPage.transferTable.status"),
        field: "status",
        // sortable: true,
        unSortIcon: true,
        cellRendererFramework: "statusInTable",
        flex: 1,
        minWidth: 200
      },
      // {
      //   colId: 6,
      //   headerName: "توضیحات",
      //   field: "description",
      //   // sortable: true,
      //   unSortIcon: true,
      //   flex: 1,
      //   width: 200
      // },
      {
        colId: 6,
        headerName: "",
        field: "verify",
        pinned: this.$vuetify.breakpoint.smAndDown
          ? ""
          : this.$vuetify.rtl
          ? "left"
          : "right",
        width: 120,
        cellRendererFramework: "verifyInTable",
        headerClass: "feature-cell header-table-ag-grid-cell"
      },
      {
        colId: 7,
        headerName: this.$t("transactionsPage.transferTable.action"),
        field: "operation",
        pinned: this.$vuetify.breakpoint.smAndDown
          ? ""
          : this.$vuetify.rtl
          ? "left"
          : "right",
        width: 120,
        cellRendererFramework: "detailsInTable",
        headerClass: "feature-cell header-table-ag-grid-cell"
      }
    ];
    this.defaultWalletHeader = {
      headerClass: "header-table-ag-grid-cell",
      lockPosition: true,
      icons: {
        sortUnSort:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>',
        sortAscending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#500fe9"></path></svg>',
        sortDescending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#500fe9"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>'
      }
    };
    this.paginationPageSize = 10;
    // this.paginationNumberFormatter = params => {
    //   return "[" + params.value.toLocaleString() + "]";
    // };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.initRouteQuery();
    this.getTransferOrderData(this.getQueryParams, this.page);
    this.getFilterStatusList();
    // this.setTransactionsCategory(this.$route.query.category);
  },
  methods: {
    ...mapActions({
      transactionsDrawerAction:
        types.transactions.actions.ACTION_TRANSACTIONS_DRAWER,
      // setTransactionsCategory:
      //   types.transactions.actions.ACTION_TRANSACTIONS_CATEGORY,
      transactionOrderData:
        types.transactions.actions.ACTION_TRANSACTIONS_ORDER,
      transactionStatusListAction:
        types.transactions.actions.ACTION_TRANSACTIONS_STATUS_LIST,
      setFiltersStatus: types.transactions.actions.ACTION_TRANSACTIONS_STATUS
    }),
    getFilterStatusList() {
      TransactionService.getFiltersStatus(this.statusQuery).then(response => {
        this.setFiltersStatus(response.data.data);
        this.statusList = response.data.data;
      });
    },
    toggledDrawerState() {
      return this.transactionsDrawer;
    },
    initRouteQuery() {
      this.$router.push(
        {
          query: { ...this.getQueryParams }
        },
        () => {}
      );
    },
    filtersDrawerFunc() {
      this.transactionsDrawerAction(!this.toggledDrawerState());
    },
    getTransferOrderData(query, paginate) {
      this.requestQuery = {
        page: paginate || this.page,
        ...query
      };
      TransactionService.getTransferOrders(this.requestQuery)
        .then(response => {
          this.transactionOrderData(response.data);
        })
        .finally(() => {
          if (this.loading) {
            this.loading = false;
          }
        });
    },
    formatDate(date) {
      return dayjs(date).format("YYYY/MM/DD");
    },
    formatTimes(time) {
      return dayjs(time).format("mm : HH");
    },
    getTransferPerPage(page) {
      this.loading = true;
      this.getTransferOrderData(this.getQueryParams, page);
    },
    remove(statusItem) {
      let queryObj = { ...this.getQueryParams };
      queryObj.status = queryObj.status.filter(
        elem => elem !== statusItem.value
      );
      if (
        Object.entries(queryObj).length === 1 &&
        queryObj.status.length === 0
      ) {
        queryObj = {};
        this.getTransferOrderData(queryObj);
      }
      this.$router.replace({ query: { ...queryObj } }, () => {});
    },
    resetFilters() {
      this.$router.replace({ query: {} }, () => {});
      // this.getTransferOrderData(this.getQueryParams, this.page);
    }
  }
};
